import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/services/api';
import { Patient } from 'src/models';
import { UseQueryOverrideOptions } from '../common';

export type GetPatientDetailsResponse = Patient;

export type UseGetPatientDetailsParams = {
  patientId: string | number;
};

export const useGetPatientDetails = (
  { patientId }: UseGetPatientDetailsParams,
  options: UseQueryOverrideOptions<GetPatientDetailsResponse> = {}
) => {
  return useQuery({
    enabled: !!patientId,
    ...options,
    queryKey: ['patient', patientId],
    queryFn: () =>
      api
        .get<GetPatientDetailsResponse>(`/v2/patients/${patientId}`)
        .then((response) => response.data),
  });
};

export const usePatientDetailsClient = () => {
  const queryClient = useQueryClient();

  const deletePatient = ({ patientId }: UseGetPatientDetailsParams) => {
    queryClient.removeQueries({ queryKey: ['patient', patientId] });
  };

  const invalidate = ({ patientId }: UseGetPatientDetailsParams) => {
    queryClient.invalidateQueries({ queryKey: ['patient', patientId] });
  };

  return { deletePatient, invalidate };
};
